import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./common-component/Header";
import { commonservices, CountCharacter } from "../services/CommonServices";
import scale from "../assets/images/log-scale.svg";
import cross from "../assets/images/log-cross.svg";
import minus from "../assets/images/log-minus.svg";

function Layout() {
    return (
        <>
            <Header />
            <Outlet />
            <div id="userlogpanel" className={"userlogpanel"}>
                <div className={"action"}>Logs
                    <img src={minus} className="cursor-pointer min" onClick={(e) => commonservices.UserLogPanalAction("minimize")} />
                    <img src={scale} className="cursor-pointer max" onClick={(e) => commonservices.UserLogPanalAction("maximize")} />
                    <img src={cross} className="cursor-pointer close" onClick={(e) => commonservices.UserLogPanalAction("close")} />
                </div>
                <div className={"logs"} id="userlogpanel_logs"></div>
            </div>
            {/* <div className="screen-loading"></div> */}
        </>
    );
}

export default Layout;
